<style scoped>
    @import url("../../../styles/contadorAguaPage/v3/medidores.scss");
</style>

<template>
    <div class="box_targetSearchCA">

        <div class="label"><span class="ml-2">Grupo</span></div>

        <div class="boxTitGeralConsumidor">
            <span class="ml-2" v-if="!flagEditNome">{{ nomeA }}</span>

            <v-form v-if="!flag_loading_A && flagEditNome" class=""
            ref="form"
            v-model="valid"
            lazy-validation
            >
                <v-text-field 
                color="orange"
                v-model="nomeMalhaEditing"
                :rules="nameRules"
                :label="nomeA"
                required
                style="width: 300px;"
                ></v-text-field>
            </v-form>

            <v-btn color="success" x-small v-if="flagEditNome" @click="changeName()">Atualizar nome</v-btn>
        
            <span v-if="flagError_A && !flag_loading_A"
            :style="{'margin-top':'10px','color':'red','font-size':'0.8rem'}">
                {{ msgError_A }}
            </span>
        </div>

        <v-dialog v-model="flagDialogC" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogC :t="'NOVO NOME'" :icon="'mdi-alert'" :msgFromInput="'Escolha outro nome ainda não existente no sistema.'"
                @fromInput="desableDialog($event)" :flagStrTipoDialog="'dialogC'"
                />
            </div>
        </v-dialog>

        <v-dialog v-model="flagDialogB" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogB :flagStrTipoDialog="'des'" :t="'Desativar grupo'" :icon="'mdi-alert'" 
                :idMalha="idMalha" :idGrupo="idGrupo"
                @fromDes="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <!-- REATIVAÇAO -->
        <v-dialog v-model="flagDialogD" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogB :flagStrTipoDialog="'reat'" :t="'Reativar grupo'" :icon="'mdi-alert'" 
                :idMalha="idMalha" :idGrupo="idGrupo"
                @fromReat="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <div class="edits">
            <v-btn small class="mt-1" v-if="!flagEditNome" @click="flagEditNome = true">
                <span>Editar nome grupo</span>
                <v-icon class="ml-1">mdi-square-edit-outline</v-icon>
            </v-btn>

            <v-btn outlined color="red" small class="mt-1 ml-1" v-if="!flagEditNome && !flagDes"
            @click="flagDialogB = true">
                <span>Desativar grupo</span>
                <v-icon class="ml-1">mdi-water-remove-outline</v-icon>
            </v-btn>

            <v-btn outlined color="green" small class="mt-1 ml-1" v-if="!flagEditNome && flagDes"
            @click="flagDialogD = true">
                <span>Reativar grupo</span>
                <v-icon class="ml-1">mdi-water-plus-outline</v-icon>
            </v-btn>
        </div>

        <!-- GRAFICOS -->
        <div class="titGeral mt-4">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-counter</v-icon>
            <span class="ml-2">Balanço hídrico</span>
        </div>

        <div class="boxGraf mt-4">
            <div class="elGraf">
                <div class="semDadosGraf" v-if="!flagApex">
                    <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
                    <div>AINDA NÃO HÁ DADOS</div>
                </div>

                <apexchart v-if="flagApex" class="ajusteApexGraf" ref="chartA" :series="series" :options="options"></apexchart>
            </div>

            <div class="elGraf">
                <div class="semDadosGraf" v-if="!flagApex">
                    <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
                    <div>AINDA NÃO HÁ DADOS</div>
                </div>

                <apexchart v-if="flagApex" class="ajusteApexGraf" ref="chart" :series="seriesB" :options="optionsB"></apexchart>
            </div>

            <div class="elGraf">
                <div class="semDadosGraf" v-if="!flagApex">
                    <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
                    <div>AINDA NÃO HÁ DADOS</div>
                </div>
                
                <div class="infoGraf" v-if="flagApex">
                    <span class="tit mt-4">Consumo do grupo</span>

                    <div class="content">
                        <span class="content_t">Período: </span>
                        <span class="content_c">{{ p }}</span>

                        <span class="content_t">Entrada acumulada no grupo: </span>
                        <span class="content_c">{{ en }}</span>

                        <span class="content_t">Saída acumulada no grupo: </span>
                        <span class="content_c">{{ ss }}</span>

                        <span class="content_t">Desperdício acumulado: </span>
                        <span class="content_c">{{ dd }}</span>
                        <span class="content_c">{{ ddp }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- MEDIDORES -->
        <div class="titGeral mt-4">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-counter</v-icon>
            <span class="ml-2">Medidores</span>
        </div>

        <!-- Caixa de diálogo: input string | USADO PARA LIST IN E TAMBÉM PARA LIST OUT -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="">
                <!-- O componente form -->
                <DialogA :flagStrTipoDialog="flagStrTipoDialog" :t="titDinamInput" :icon="'mdi-counter'" 
                @fromInput="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <v-btn block small class="mt-4" @click="openDialog('IN')">
            <span>Adicionar nova entrada</span>
            <v-icon class="ml-1">mdi-plus-box-outline</v-icon>
        </v-btn>

        <!-- PAINEL ENTRADAS -->
        <div class="label mt-2"><span class="ml-2">Todas as entradas</span></div>

        <div class="painelGeralConsumidor">

            <div class="headersClasses" :style="{'border':'1px solid rgba(7,46,79,0.8)'}">
                <div class="hCard">ID</div>
                <div class="hCard">Medidor</div>
                <div class="hCard">Última leitura [m3]</div>
                <div class="hCard">Status</div>
                <div class="hCard">Alarmes</div>
                <div class="hCard" :style="{'justify-self':'flex-end'}">Ação</div>
            </div>

            <div class="boxLi">
                <div class="liClasses" v-for="(cont,r) in liIN" :key="r"
                :style="{'background':cont.b}"
                @mouseover="changeBtn(r,'on','liIN')"
                @mouseleave="changeBtn(r,'off','liIN')"
                @click="callTarget(r,'IN')"
                >
                    <div class="hCard">{{ cont.idd }}</div>
                    <div class="hCard">{{ cont.t }}</div>
                    <div class="hCard">{{ cont.lastR }}</div>
                    <div class="hCard">{{ cont.status }}</div>
                    <div class="hCard">{{ cont.alarme }}</div>

                    <v-icon class="hCard">mdi-square-edit-outline</v-icon>
                    <v-icon class="hCard">mdi-water-remove-outline</v-icon>
                </div>
            </div>

        </div>

        <v-btn block small class="mt-4" @click="openDialog('OUT')">
            <span>Adicionar nova saída</span>
            <v-icon class="ml-1">mdi-plus-box-outline</v-icon>
        </v-btn>

        <!-- PAINEL SAIDAS -->
        <div class="label mt-2"><span class="ml-2">Todas as saídas</span></div>

        <div class="painelGeralConsumidor">

            <div class="headersClasses" :style="{'border':'1px solid rgba(7,46,79,0.8)'}">
                <div class="hCard">ID</div>
                <div class="hCard">Medidor</div>
                <div class="hCard">Última leitura [m3]</div>
                <div class="hCard">Status</div>
                <div class="hCard">Alarmes</div>
                <div class="hCard" :style="{'justify-self':'flex-end'}">Ação</div>
            </div>

            <div class="boxLi">
                <div class="liClasses" v-for="(cont,r) in liOUT" :key="r"
                :style="{'background':cont.b}"
                @mouseover="changeBtn(r,'on','liOUT')"
                @mouseleave="changeBtn(r,'off','liOUT')"
                @click="callTarget(r,'OUT')"
                >
                    <div class="hCard">{{ cont.idd }}</div>
                    <div class="hCard">{{ cont.t }}</div>
                    <div class="hCard">{{ cont.lastR }}</div>
                    <div class="hCard">{{ cont.status }}</div>
                    <div class="hCard">{{ cont.alarme }}</div>

                    <v-icon class="hCard">mdi-square-edit-outline</v-icon>
                    <v-icon class="hCard">mdi-water-remove-outline</v-icon>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import DialogA from './DialogA'
import DialogB from './DialogB'
import DialogC from './DialogC'

export default {

    components:{DialogA,DialogB,DialogC},

    props:['idMalha','idGrupo'],

    data() {
        return {
            // balanço do grupo
            liValuesLeituras:[],

            //
            liIN:[
                {
                    'idd':0,
                    't':'UP/6541668',
                    'lastR':1052.5, // m3.
                    'initDate':'01/11/2024', // instalação do contador.
                    'endDate':'-',
                    'status':'Ligado',
                    'alarme':'-',
                    'b':''
                }
            ],
            liOUT:[
                {
                    'idd':0,
                    't':'UP/6541668',
                    'lastR':1052.5, // m3.
                    'initDate':'01/11/2024', // instalação do contador.
                    'endDate':'-',
                    'status':'Ligado',
                    'alarme':'-',
                    'b':''
                },
                {
                    'idd':1,
                    't':'Teste',
                    'lastR':2324, // m3.
                    'initDate':'01/11/2024', // instalação do contador.
                    'endDate':'-',
                    'status':'Desligado',
                    'alarme':'-',
                    'b':''
                }
            ],

            // dialog dinamico (entrada ou saida)
            flagDialog:false,
            titDinamInput:'',
            flagDialogB:false, // desativação grupo
            flagDialogC:false,
            flagDialogD:false, // reativação grupo

            flagDes:false, // indica se o grupo está ativo. false => ativo.

            //
            items:[], // init empty then is it filled by loop on created.
            hoverSearch:'rgb(247,215,46)',
            valueSelected: '',
            fullContInfo:'', // preenchido após selected value by autocomplete search.

            // edit nome titulo
            nomeA:'Grupo X', // nome init
            flagEditNome:false,
            nomeMalhaEditing:'',
            valid: false, // btn 'entrar' inicia desabilitado.
            nameRules: [
                v => !!v || 'Preenchimento obrigatório',
            ],
            flag_loading_A:false,
            flagError_A:false,
            msgError_A:'Nome inválido',

            // painel de visualização de consumo
            p:'03/11/2024 - 10/11/2024',
            en:'1.63 [m3]',
            ss:'1.33 [m3]',
            dd:'0.3 [m3]',
            ddp:'19.88%',

            //
            flagApex:true,
            series: [
                {
                    name: 'Entrada',
                    type: 'column',
                    //data: [18, 20, 22, 20, 16, 15],
                    data: [0, 0, 0, 0, 0, 0]
                },
                {
                    name: 'Saída',
                    type: 'line',
                    data: [0, 0, 0, 0, 0, 0],
                    dashArray: 5  // Define a linha como pontilhada
                }
            ],
            options:{
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false  // Desativa o menu (toolbar)
                    },
                    //width: '280px' // Pode ser um valor em pixels (px) ou percentual (%)
                },
                stroke: {
                    width: [0, 4],
                    dashArray: [0, 5]  // Faz a segunda série (linha) ser pontilhada
                },
                labels: ['', '', '', '', '', ''],
                yaxis: { 
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2); // 2 casas decimais
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value.toFixed(2); // Limita a 2 casas decimais
                        }
                    }
                },
            },
            // chart nivel agua
            seriesB: [
                {
                    name: 'Desperdício',
                    type: 'column',
                    data: [0, 0, 0, 0, 0, 0]
                },
                {
                    name: 'Alvo',
                    type: 'line',
                    data: [0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0],
                    dashArray: 5  // Define a linha como pontilhada
                }
            ],
            optionsB:{
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false  // Desativa o menu (toolbar)
                    },
                    //width: '280px' // Pode ser um valor em pixels (px) ou percentual (%)
                },
                stroke: {
                    width: [0, 3],
                    dashArray: [0, 5]  // Faz a segunda série (linha) ser pontilhada
                },
                labels: ['', '', '', '', '', ''],
                colors: ['#1E90FF', '#FF4500'],
                yaxis: { 
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2); // 2 casas decimais
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value.toFixed(2); // 2 casas decimais
                        }
                    }
                }
            },
        }
    },

    methods:{

        desableDialog(flagLi) { 

            this.flagDialog = flagLi[0]
            var flagStrTipoDialog = flagLi[2] // 'IN' or 'OUT' rcv from emit OR 'del or 'dialogC''

            if (flagStrTipoDialog == 'dialogC') {
                this.flagDialogC = false // dasabilitar alerta de input errado.
                return
            }

            if (flagStrTipoDialog == 'des' || flagStrTipoDialog == 'reat') { 
                this.flagDialogB = false;

                // redirecionar para a hierarquia anterior.
                const r = this.$route.params // Captura os parâmetros da rota atual
                //console.log('routeParams: ',r)
                var rotaPush = `/ca/malhas/${r.idMalha}/grupos`
                //console.log('rotaPush: ',rotaPush)
                this.$router.push(rotaPush)

                return;
            } // -- op no component dialogB.

            // Obter data de hoje.
            const { getDataAtualGMT, getHoraAtualGMT } = require('../../../ferramentas/dataHoraGMT.js');

            var idM = 0
            if (flagStrTipoDialog == 'IN') { idM = this.liIN.length } else { idM = this.liOUT.length }
            
            // -- verificar unicidade do nome a ser inputado. (o nome deve ser único).
            //console.log('verificando nome...')
            var novoNome = flagLi[1]
            // -- verificar todo o db.
            var malhas = this.$store.state.liMalhas
            var qntMalhas = malhas.length
            var grupos = []
            var qntGrupos = 0
            var saidas = []
            var entradas = []
            var qntOUT = 0 // int
            var qntIN = 0 // int
            var m = 0
            while (m < qntMalhas) {
                if (malhas[m].malha == novoNome) { this.flagDialogC = true; return }
                qntGrupos = malhas[m].grupos.length // int
                grupos = malhas[m].grupos // list
                var c = 0
                while (c < qntGrupos) {
                    if (grupos[c].grupo == novoNome) { this.flagDialogC = true; return }
                    qntOUT = grupos[c].saidas.length // int
                    qntIN = grupos[c].entradas.length // int
                    saidas = grupos[c].saidas // list
                    entradas = grupos[c].entradas // list
                    var vm = 0
                    while (vm < qntOUT) {
                        if (saidas[vm].nome == novoNome) { this.flagDialogC = true; return }
                        vm++
                    }
                    var vz = 0
                    while (vz < qntIN) {
                        if (entradas[vz].nome == novoNome) { this.flagDialogC = true; return }
                        vz++
                    }
                    c++
                }
                m++
            }
            //console.log('nome verificado.')

            var novoMedidor = {
                'id':idM,
                'nome':novoNome, // nome recebido via evento component child.
                'ultima_leitura':0, // init
                'instalacao':getDataAtualGMT(), // DESNECESSÁRIO. (info no eventos)
                //'desinstalacao':'-', // DESNECESSÁRIO. (info no eventos)
                'status':'Desativado', // init
                'coord':[40.27899076267598,-7.504206597805024], // tornar dinam
                'eventos':[
                  {
                    'data':getDataAtualGMT(),
                    'hora':getHoraAtualGMT(),
                    'origem':flagStrTipoDialog,
                    'tipo':'Criação', // init
                    'nota':'-'
                  },
                ],
                'leituras':[],
            }
            if (flagStrTipoDialog == 'IN') {
                this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].entradas.push(novoMedidor)
                //this.liIN.push(novoMedidor) // update local page é feito no init()
            } else {
                this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].saidas.push(novoMedidor)
                //this.liOUT.push(novoMedidor) // update local page é feito no init()
            }

            this.init(true) // remontar página com novo medidor adiconado. flagNewDevice=true
        },

        openDialog(flagStrTipoDialog)  {

            if (flagStrTipoDialog == 'IN') { this.titDinamInput = 'Nova Entrada' }
            else { this.titDinamInput = 'Nova Saída' }
            this.flagStrTipoDialog = flagStrTipoDialog
            this.flagDialog = true
        },

        changeName() {
            this.flag_loading_A = true // iniciar loading...

            if (this.nomeMalhaEditing.length >= 2) {

                if (this.$refs.form.validate()) {

                    // EDITAR NOME DO GRUPO AQUI !!! ALTERAR 30/01/2025

                    this.flag_loading_A = false // desabilitar loading
                    this.flagError_A = false // reset flag error

                    this.nomeA = this.nomeMalhaEditing
                    this.nomeMalhaEditing = '' // reset var input

                    // up store
                    this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].grupo = this.nomeA

                    this.flagEditNome = false // desable edit.
                }

            } else {
                
                this.flag_loading_A = false // desabilitar loading
                this.flagError_A = true

                //this.flagEditNome = false // desable edit.
                return
            }
        },

        // -- change background color when mouse over and leave.
        changeBtn(index,strFlag,strFlagLiTipo) { 
            if (strFlag == 'on') { 
                if (strFlagLiTipo == 'liOUT') {
                    this.liOUT[index].b = 'rgb(247,215,46)' 
                } else {
                    this.liIN[index].b = 'rgb(247,215,46)' 
                }
            }
            else { 
                if (strFlagLiTipo == 'liOUT') {
                    if (this.liOUT[index].status == 'Desativado') { this.liOUT[index].b = 'rgba(255,0,0,0.3)' }
                    else { this.liOUT[index].b = ''  }
                } else {
                    if (this.liIN[index].status == 'Desativado') { this.liIN[index].b = 'rgba(255,0,0,0.3)' }
                    else { this.liIN[index].b = ''  }
                }
            }
        },

        callTarget(index,flagStrMedidor) { 

            //var idMalhaSelected = this.$store.state.jTmpMalha.idMalha // via store.
            var idMalha = this.idMalha // via props rota aninhada.
            var idGrupo = this.idGrupo // via props rota aninhada.
            //console.log('[medidores] idGrupo: ',idGrupo)

            if (flagStrMedidor == 'OUT') {
                //console.log('Medidor de saída selecionado: ',index)
                var idOUT = index
                this.$router.push(`/ca/malhas/${idMalha}/grupos/${idGrupo}/medidores/saida/${idOUT}`);

            } else {
                //console.log('Medidor de entrada selecionado: ',index)
                var idIN = index
                this.$router.push(`/ca/malhas/${idMalha}/grupos/${idGrupo}/medidores/entrada/${idIN}`);
            }
        },

        getDifDate(dateDes, dateReat) {
            console.log('Data de desativação: ',dateDes)
            console.log('Data de reativação: ',dateReat)

            // -- converter date string para o formato de cálculo.

            //const data1 = Date.UTC(2025, 2, 24); // Março é mês 2 (zero-based)
            //const data2 = Date.UTC(2025, 3, 1);
            //const diferencaEmDias = (data2 - data1) / (1000 * 60 * 60 * 24);
            //console.log(`Diferença em dias: ${diferencaEmDias}`);

        },

        mountAgrup(tmpLiIN) {
            // -- função agrupa os valores das medições para um dia, de todos os medidores.
            // -- serve para medidores de entrada e também saída.

            var tmpBackColor = ''
            var tam = tmpLiIN.length
            var liExib = []
            var liDatesAgrupadas = [] // cada posição da lista é um medidor com as leituras agrupadas por dia.
            var c = 0
            while (c < tam) { // varrer todas os medidores de entrada desse grupo.

                if (tmpLiIN[c].status == 'Desativado') { tmpBackColor = 'rgba(255,0,0,0.3)' }
                else { tmpBackColor = '' }

                // -- Contar qnts alarmes ativos. Por enquanto contar todos existentes. 30/01/25
                //console.log('pre verif eventos')
                var liDateDes = []
                var liDateReat = []
                let a=0
                let countAlarmes=0
                while (a < tmpLiIN[c].eventos.length) {

                    if (tmpLiIN[c].eventos[a].tipo == 'Desativação') {
                        // -- obter data de desativação.
                        liDateDes.push(tmpLiIN[c].eventos[a].data)
                        let b = a // -- iniciar busca de reativação a partir da desativação.
                        while (b < tmpLiIN[c].eventos.length) {
                            if (tmpLiIN[c].eventos[b].tipo == 'Reativação') {
                                // -- obter data de reativação após desativação.
                                liDateReat.push(tmpLiIN[c].eventos[b].data)
                                //this.getDifDate(dateDes, dateReat) // obter diferença de dias entre datas, se houver.
                                b = tmpLiIN[c].eventos.length // encerrar subloop b.
                            }
                            b++
                        }
                    }
                    
                    if (tmpLiIN[c].eventos[a].tipo == 'Alarme') { countAlarmes++ }
                    a++
                }
                //console.log('liDateDes: ',liDateDes)
                //console.log('liDateReat: ',liDateReat)

                liExib.push({
                    'idd':tmpLiIN[c].id,
                    't':tmpLiIN[c].nome,
                    'lastR':tmpLiIN[c].ultima_leitura, // m3.
                    //'initDate':tmpLiIN[c].instalacao, // instalação do contador.
                    //'endDate':tmpLiIN[c].desinstalacao,
                    'status':tmpLiIN[c].status,
                    'alarme':countAlarmes,
                    'b':tmpBackColor
                    }
                )

                // SUB LOOP | agrupar todas as leituras realizados em um mesmo dia.
                if (tmpLiIN[c].leituras.length > 0) {
                    //console.log('init sub looop')
                    var flagDes = false // init flag indicando que o medidor está ativo.
                    if (liDateDes.length > 0) { 
                        //console.log('desativação identificada')
                        var c_des = 0 // contador de período desativado.
                        var dateDes = liDateDes[c_des] // string date init período desativado
                        var c_reat = 0 // supondo que exista um dia de reativaçao.
                        //c_des++
                    }
                    var initDate = tmpLiIN[c].leituras[0].data // init | obter date inicial.
                    var liDia = [] // lista acumuladora das leituras para um mesmo dia.

                    // Se para esse dia o medidor está desativado, então somar 0.
                    //console.log('initDate (p1): ',initDate)
                    //console.log('dateDes (p1): ',dateDes)
                    if (dateDes == initDate) {
                        //liDia.push({'data':initDate,'soma':0}) 
                        flagDes = true // a partir desse dia, o medidor está desativado para os prox dias.
                    }

                    var c_in = 0
                    var soma = 0
                    while (c_in < tmpLiIN[c].leituras.length) {
                        if (initDate == tmpLiIN[c].leituras[c_in].data) {
                            // agrupar todas as leituras obtidas no mesmo dia, para esse medidor [c].
                            // Se não estiver desativado neste dia.
                            if (flagDes == true) {
                                soma = soma + 0
                            } else {
                                soma = soma + tmpLiIN[c].leituras[c_in].leitura
                            }
                            // se for a ultima iteração, agrupar antes de finalizar o sub loop. ~laço while~
                            if (c_in == tmpLiIN[c].leituras.length-1) { 
                                liDia.push({'data':initDate,'soma':soma}) 
                            }
                        } else {
                            liDia.push({'data':initDate,'soma':soma})
                            soma = 0 // reset soma
                            // se não for a mesma date, passar para o próximo dia de leituras.
                            initDate = tmpLiIN[c].leituras[c_in].data

                            //console.log('liDateReat.length (p2): ',liDateReat.length)
                            //console.log('c_reat (p2): ',c_reat)
                            // verif. se é um dia desativado ou se reativou.
                            // para verif, deve haver pelo menos 1 posição de reativação.
                            if (flagDes == true && liDateReat.length > c_reat) {
                                if (initDate == liDateReat[c_reat]) {
                                    // se o novo dia é um dia de reativação, reativar acumulação.
                                    flagDes = false
                                    c_reat++
                                }
                            }

                            // se estiver ativado, verif se o novo dia é um dia desativado.
                            if (liDateDes.length > c_des) {
                                //console.log('initDate (p2): ',initDate)
                                //console.log('dateDes (p2): ',liDateDes[c_des])
                                if (initDate == liDateDes[c_des]) {
                                    flagDes = true // a partir desse dia, o medidor está desativado para os prox dias.
                                    c_des++
                                }
                            }

                            // se não estiver desativado neste dia.
                            if (flagDes == true) {
                                soma = soma + 0
                            } else {
                                // agrupar todas as leituras obtidas no mesmo dia.
                                soma = soma + tmpLiIN[c].leituras[c_in].leitura
                            }
                        }
                        c_in++
                    }
                    liDatesAgrupadas.push(liDia) // lista de listas. Correção: lista contendo uma lista de objs.
                }
                c++
            }

            //console.log('pre loop agrup main')
            // -- Apenas se houver mais de 1 medidor. Somar todas as leituras para o mesmo dia, de todos os medidores.
            // if (liDatesAgrupadas.length > 1) {} // sem if => loop será executado, mesmo apenas 1 vez.
            var refDate = '' //liDatesAgrupadas[0][0].data // date inicial do primeiro medidor.
            //var liRefin = [] // dinam
            var liSecin = [] // dinam
            var liFinalIN = [] // ?
            var liFinalIN_apex = []
            var inG = 0
            var inA = 0
            var inB = 0 // [[a,b,c],[a,b],[c,d]]
            var somaIN = 0
            if (liDatesAgrupadas.length > 0) {
                while (inG < liDatesAgrupadas[0].length) { // laço geral. Lista ref.
                    // começar varrendo toda a lista ref
                    refDate = liDatesAgrupadas[0][inG].data // obter prox el date da lista ref
                    somaIN = liDatesAgrupadas[0][inG].soma // ref soma
                    inA=1 // reset (iniciar a verredura de um novo medidor).
                    while (inA < liDatesAgrupadas.length) {
                        // A partir da posição [1] varrer toda a lista global.
                        liSecin = liDatesAgrupadas[inA] // varrendo todas as dates do medidor [inG+1].
                        while (inB < liSecin.length) { // varrer toda a lista secundária
                            if (refDate == liSecin[inB].data) { // se as dates forem iguais, somar float
                                somaIN = somaIN + liSecin[inB].soma
                                break // após soma interromper e buscar prox dia inA.
                            }
                            inB++
                        }
                        inA++
                    }
                    // após varrer todos os medidores, somou todas as dates para date ref.
                    liFinalIN.push({'data':refDate,'soma':somaIN})
                    liFinalIN_apex.push(somaIN) // atenção. (formato apex precisa ser list)
                    inG++
                }
            }
            return [liExib, liFinalIN, liFinalIN_apex]
        },

        init() {
            
            this.nomeA = this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].grupo

            // reset (limpar)
            this.liIN = []
            this.liOUT = []

            // init lista IN
            var tmpLiIN = this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].entradas
            //console.log('tmpLiIN: ',tmpLiIN)
            
            // verif status grupo atual.
            // Se desativada, então flagDes = true | flagDes = false (default/init)
            if (this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].status == 'Desativado') { 
                this.flagDes = true 
            }
            //console.log('this.flagDes [grupo]: ',this.flagDes)

            // -- Se o elemento não é undefined, null ou tem length < 1.
            //console.log('!tmpLiIN[0].leituras?.length: ',!tmpLiIN[0].leituras?.length)
            if (tmpLiIN.length > 0) {
            //if (!tmpLiIN[0].leituras?.length == false) {
                //console.log('entrou?')

                var liRcvIn = this.mountAgrup(tmpLiIN)
                //console.log('after mountAgrup()')
                var liExibIN = liRcvIn[0]
                var liFinalIN = liRcvIn[1]
                var liFinalIN_apex = liRcvIn[2]
                //console.log('liFinalIN: ', liFinalIN) // lista usada na operação de subtração (desperdício).
                this.liIN = liExibIN // lista de medidores exibida no front.

                this.series[0].data = liFinalIN_apex
            }

            // init lista OUT
            var tmpLiOUT = this.$store.state.liMalhas[this.idMalha].grupos[this.idGrupo].saidas

            //if (!tmpLiOUT[0].leituras?.length == false) {
            if (tmpLiOUT.length > 0) {
                //console.log('tmpLiOUT.length: ',tmpLiOUT.length)

                var liRcvOut = this.mountAgrup(tmpLiOUT)
                var liExibOut = liRcvOut[0]
                var liFinalOut = liRcvOut[1]
                var liFinalOut_apex = liRcvOut[2]
                //console.log('liFinalOut: ', liFinalOut) // lista usada na operação de subtração (desperdício).
                this.liOUT = liExibOut // lista de medidores exibida no front.

                this.series[1].data = liFinalOut_apex
            }

            // -- Se o elemento não é undefined, null ou tem length < 1.
            //if (!tmpLiIN[0].leituras?.length == true && !tmpLiOUT[0].leituras?.length == true) {
            if (tmpLiIN.length == 0 && tmpLiOUT.length == 0) {
                this.flagApex = false // não há dados para exibir no gráfico.
            }

            // -- versão subtração simplificada (sem date).
            /*if (this.flagApex == true) {
                if (liFinalIN_apex.length == liFinalOut_apex.length) {
                    // -- subtrair listas.
                    let d = 0
                    var sub = 0
                    var liAlvo = []
                    var liDesperdicio = []
                    while (d < liFinalOut_apex.length) {
                        // condicionar date antes de subtrair.
                        sub = liFinalIN_apex[d] - liFinalOut_apex[d]
                        liDesperdicio.push(sub)
                        liAlvo.push(sub-(sub*0.2)) // redução de 20% do desperdício.
                        d++
                    }
                    //nsole.log('liDesperdicio: ',liDesperdicio)
                    this.seriesB[0].data = liDesperdicio
                    this.seriesB[1].data = liAlvo
                }
            }*/

            //console.log('pre end algoritmo')
            // -- versão com date.
            if (tmpLiIN.length > 0 && tmpLiOUT.length > 0) { // se houver entrada & saída.
                //console.log('tmpLiOUT: ',tmpLiOUT)
                //console.log('liFinalOut: ',liFinalOut)
                
                let d = 0
                var sub = 0
                var refDate = ''
                var liAlvo = []
                var liDesperdicio = []
                while (d < liFinalIN.length) {
                    // condicionar date antes de subtrair.
                    refDate = liFinalIN[d].data
                    let u = 0
                    while (u < liFinalOut.length) {
                        if (refDate == liFinalOut[u].data) {
                            sub = liFinalIN[d].soma - liFinalOut[u].soma
                            liDesperdicio.push(sub)
                            liAlvo.push(sub-(sub*0.2)) // redução de 20% do desperdício.
                        }
                        u++
                    }
                    d++
                }
                this.seriesB[0].data = liDesperdicio
                this.seriesB[1].data = liAlvo
            }
        },
    },

    created() {
        window.scrollTo(0,0)

        this.init()
    }
}
</script>